





































































































































































import { Component, Mixins, Ref, Prop, Emit } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { PromptTemplate, DefaultPromptTemplate } from "#/model/admin/index";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm, Choice } from "@/types";
import OpenAISetting from "@/components/ai/OpenAISetting.vue";
import GeminiSetting from "@/components/ai/GeminiSetting.vue";
import { LLM_TYPE } from "@/views/aivnplan/const";

@Component({ components: { OpenAISetting, GeminiSetting } })

/** プロンプトテンプレート編集 */
export default class PromptTemplateEditor extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */

  /** フォーム操作用 */
  @Ref("form") private readonly form!: VForm;

  /** Prop */

  /** プロンプトテンプレート */
  @Prop({
    default: () => {
      DefaultPromptTemplate;
    },
  })
  private promptTemplate!: PromptTemplate;

  /** 変数 */

  /** 編集モードフラグ */
  private isEditMode = false;

  /** テンプレート種類選択肢 */
  private typeChoice: Choice[] = [
    {
      text: "未選択(その他)",
      value: 0,
    },
    {
      text: "本誌",
      value: 1,
    },
    {
      text: "別添",
      value: 2,
    },
  ];

  /** LLMサービス選択肢 */
  private llmServiceChoice: Choice[] = [
    {
      text: "OpenAI",
      value: LLM_TYPE.OPEN_AI,
    },
    {
      text: "Gemini",
      value: LLM_TYPE.GEMINI,
    },
  ];

  private LLM_TYPE = LLM_TYPE;

  /** 関数 */

  /** 編集モード切り替え */
  private toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  private async beforeSavePrompt() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.savePrompt();
  }

  private async beforeDeletePrompt() {
    if (!(await this.$openConfirm("削除します。よろしいですか？"))) {
      return;
    }

    this.deletePrompt();
  }

  /** Emit */

  @Emit("save:prompt")
  private savePrompt() {
    return;
  }

  @Emit("delete:prompt")
  private deletePrompt() {
    return;
  }

  @Emit("cancel:prompt")
  private cancelPrompt() {
    return;
  }
}
